export default "__VITE_ASSET__1d3781b4__"